'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var VehicleGpsTrackingAppIcon = function VehicleGpsTrackingAppIcon(props) {
  if (props.variant === 'light') {
    return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
      viewBox: "0 0 621.08 621.08"
    }), React__default["default"].createElement("path", {
      style: {
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      d: "M146,500.26l310.74.75M196.58,261.74l-148-.07A27.22,27.22,0,0,0,21.31,288c-1.49,47.52-1,133.7-1.8,156.55-.11,3.44.33,8.31-1.65,10-8.64,7.4-7.4,16.84-7.07,26.29.38,11,3.23,17.26,9.08,20.18,2.86,1.43,40.86,0,40.86,0m481.36,0,66.37-.08c.93-10.86,6.75-22.86-6.4-31.27-1.39-.91-1.06-4.58-1.47-7-2.56-14.47-4.1-29.22-8-43.35-1.9-6.78-7-14.39-12.77-18.06-16.37-10.18-34.24-17.9-50.86-27.71-10.11-5.94-20.18-12.78-28.2-21.17-20.43-21.31-40.27-43.2-59.2-65.87-14.65-17.57-32.74-23.43-54.82-23.36l-97.13.1"
    }), React__default["default"].createElement("path", {
      style: {
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 15
      },
      d: "M354.61,305.3h34.31a25.56,25.56,0,0,1,19.53,9.06l49.42,58.45a2.72,2.72,0,0,1-2.07,4.5H354.61a8,8,0,0,1-8-8V313.27A8,8,0,0,1,354.61,305.3Z"
    }), React__default["default"].createElement("path", {
      style: {
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      d: "M103.85,465.09A42.24,42.24,0,0,1,146,506.92c.12,23.53-20.21,43.68-43.39,43a42.82,42.82,0,0,1-41.92-43.25C61.05,482.91,79.73,464.9,103.85,465.09Z"
    }), React__default["default"].createElement("path", {
      style: {
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      d: "M499.9,464.16A42.23,42.23,0,0,1,542.09,506c.12,23.53-20.21,43.68-43.39,43a42.82,42.82,0,0,1-41.92-43.25C457.1,482,475.78,464,499.9,464.16Z"
    }), React__default["default"].createElement("line", {
      style: {
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      x1: "20.25",
      y1: "339.3",
      x2: "198.28",
      y2: "339.3"
    }), React__default["default"].createElement("line", {
      style: {
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      x1: "20.25",
      y1: "377.31",
      x2: "301.41",
      y2: "377.31"
    }), React__default["default"].createElement("line", {
      style: {
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      x1: "602.06",
      y1: "467.68",
      x2: "571.1",
      y2: "467.68"
    }), React__default["default"].createElement("line", {
      style: {
        fill: 'none',
        stroke: '#fff',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      x1: "37.23",
      y1: "467.68",
      x2: "10.54",
      y2: "467.68"
    }), React__default["default"].createElement("path", {
      style: {
        fill: '#4ca9f6',
        stroke: '#4ca9f6',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 15
      },
      d: "M247,71.13a88.36,88.36,0,0,0-88.37,88.37c0,37.37,51.8,120.4,76.08,157.27a14.71,14.71,0,0,0,24.57,0c24.28-36.87,76.09-119.9,76.09-157.27A88.37,88.37,0,0,0,247,71.13Zm0,140.15a53.71,53.71,0,1,1,53.71-53.71A53.7,53.7,0,0,1,247,211.28Z"
    }), React__default["default"].createElement("rect", {
      style: {
        fill: 'none'
      },
      width: "621.08",
      height: "621.08"
    }));
  }

  if (props.variant === 'mono') {
    return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
      viewBox: "0 0 621.08 621.08"
    }), React__default["default"].createElement("path", {
      style: {
        fill: 'none',
        stroke: '#13191e',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      d: "m146 500.26 310.74.75M196.58 261.74l-148-.07A27.22 27.22 0 0 0 21.31 288c-1.49 47.52-1 133.7-1.8 156.55-.11 3.44.33 8.31-1.65 10-8.64 7.4-7.4 16.84-7.07 26.29.38 11 3.23 17.26 9.08 20.18 2.86 1.43 40.86 0 40.86 0m481.36 0 66.37-.08c.93-10.86 6.75-22.86-6.4-31.27-1.39-.91-1.06-4.58-1.47-7-2.56-14.47-4.1-29.22-8-43.35-1.9-6.78-7-14.39-12.77-18.06-16.37-10.18-34.24-17.9-50.86-27.71-10.11-5.94-20.18-12.78-28.2-21.17-20.43-21.31-40.27-43.2-59.2-65.87-14.65-17.57-32.74-23.43-54.82-23.36l-97.13.1"
    }), React__default["default"].createElement("path", {
      style: {
        fill: 'none',
        stroke: '#13191e',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 15
      },
      d: "M354.61 305.3h34.31a25.56 25.56 0 0 1 19.53 9.06l49.42 58.45a2.72 2.72 0 0 1-2.07 4.5H354.61a8 8 0 0 1-8-8v-56.04a8 8 0 0 1 8-7.97Z"
    }), React__default["default"].createElement("path", {
      style: {
        fill: 'none',
        stroke: '#13191e',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      d: "M103.85 465.09A42.24 42.24 0 0 1 146 506.92c.12 23.53-20.21 43.68-43.39 43a42.82 42.82 0 0 1-41.92-43.25c.36-23.76 19.04-41.77 43.16-41.58ZM499.9 464.16A42.23 42.23 0 0 1 542.09 506c.12 23.53-20.21 43.68-43.39 43a42.82 42.82 0 0 1-41.92-43.25c.32-23.75 19-41.75 43.12-41.59Z"
    }), React__default["default"].createElement("path", {
      style: {
        fill: 'none',
        stroke: '#13191e',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 15
      },
      d: "M20.25 339.3h178.03M20.25 377.31h281.16M602.06 467.68H571.1M37.23 467.68H10.54"
    }), React__default["default"].createElement("path", {
      style: {
        fill: '#13191e',
        stroke: '#13191e',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 20
      },
      d: "M247 71.13a88.36 88.36 0 0 0-88.37 88.37c0 37.37 51.8 120.4 76.08 157.27a14.71 14.71 0 0 0 24.57 0c24.28-36.87 76.09-119.9 76.09-157.27A88.37 88.37 0 0 0 247 71.13Zm0 140.15a53.71 53.71 0 1 1 53.71-53.71A53.7 53.7 0 0 1 247 211.28Z"
    }), React__default["default"].createElement("path", {
      style: {
        fill: 'none'
      },
      d: "M0 0h621.08v621.08H0z"
    }));
  }

  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 621.08 621.08"
  }), React__default["default"].createElement("path", {
    style: {
      fill: 'none',
      stroke: '#13191e',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 20
    },
    d: "M146,500.26l310.74.75M196.58,261.74l-148-.07A27.22,27.22,0,0,0,21.31,288c-1.49,47.52-1,133.7-1.8,156.55-.11,3.44.33,8.31-1.65,10-8.64,7.4-7.4,16.84-7.07,26.29.38,11,3.23,17.26,9.08,20.18,2.86,1.43,40.86,0,40.86,0m481.36,0,66.37-.08c.93-10.86,6.75-22.86-6.4-31.27-1.39-.91-1.06-4.58-1.47-7-2.56-14.47-4.1-29.22-8-43.35-1.9-6.78-7-14.39-12.77-18.06-16.37-10.18-34.24-17.9-50.86-27.71-10.11-5.94-20.18-12.78-28.2-21.17-20.43-21.31-40.27-43.2-59.2-65.87-14.65-17.57-32.74-23.43-54.82-23.36l-97.13.1"
  }), React__default["default"].createElement("path", {
    style: {
      fill: 'none',
      stroke: '#13191e',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 15
    },
    d: "M354.61,305.3h34.31a25.56,25.56,0,0,1,19.53,9.06l49.42,58.45a2.72,2.72,0,0,1-2.07,4.5H354.61a8,8,0,0,1-8-8V313.27A8,8,0,0,1,354.61,305.3Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: 'none',
      stroke: '#13191e',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 20
    },
    d: "M103.85,465.09A42.24,42.24,0,0,1,146,506.92c.12,23.53-20.21,43.68-43.39,43a42.82,42.82,0,0,1-41.92-43.25C61.05,482.91,79.73,464.9,103.85,465.09Z"
  }), React__default["default"].createElement("path", {
    style: {
      fill: 'none',
      stroke: '#13191e',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 20
    },
    d: "M499.9,464.16A42.23,42.23,0,0,1,542.09,506c.12,23.53-20.21,43.68-43.39,43a42.82,42.82,0,0,1-41.92-43.25C457.1,482,475.78,464,499.9,464.16Z"
  }), React__default["default"].createElement("line", {
    style: {
      fill: 'none',
      stroke: '#13191e',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 15
    },
    x1: "20.25",
    y1: "339.3",
    x2: "198.28",
    y2: "339.3"
  }), React__default["default"].createElement("line", {
    style: {
      fill: 'none',
      stroke: '#13191e',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 15
    },
    x1: "20.25",
    y1: "377.31",
    x2: "301.41",
    y2: "377.31"
  }), React__default["default"].createElement("line", {
    style: {
      fill: 'none',
      stroke: '#13191e',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 15
    },
    x1: "602.06",
    y1: "467.68",
    x2: "571.1",
    y2: "467.68"
  }), React__default["default"].createElement("line", {
    style: {
      fill: 'none',
      stroke: '#13191e',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 15
    },
    x1: "37.23",
    y1: "467.68",
    x2: "10.54",
    y2: "467.68"
  }), React__default["default"].createElement("path", {
    style: {
      fill: '#0f77cc',
      stroke: '#0f77cc',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: 20
    },
    d: "M247,71.13a88.36,88.36,0,0,0-88.37,88.37c0,37.37,51.8,120.4,76.08,157.27a14.71,14.71,0,0,0,24.57,0c24.28-36.87,76.09-119.9,76.09-157.27A88.37,88.37,0,0,0,247,71.13Zm0,140.15a53.71,53.71,0,1,1,53.71-53.71A53.7,53.7,0,0,1,247,211.28Z"
  }), React__default["default"].createElement("rect", {
    style: {
      fill: 'none'
    },
    width: "621.08",
    height: "621.08"
  }));
};

var VehicleGpsTrackingAppIcon$1 = iconStyles()(VehicleGpsTrackingAppIcon);

module.exports = VehicleGpsTrackingAppIcon$1;
